export default {
	"languageSwitch.buttonLabel": "Seite in anderen Sprachen",
	"languageSwitch.disabledLabel": "Seite ist nur in dieser Sprache verfügbar",
} as const;
